@if (flockVariant() === flockVariantEnum.Breeder) {
<app-breeder-flock-overview-week-registration-detailed
  [flock]="flock()"
  [flockWeekDataSet]="flockWeekDataSet()"
/>
} @else {
<app-flock-overview-week-registration-detailed
  [flock]="flock()"
  [flockWeekDataSet]="flockWeekDataSet()"
/>
}
